<template>
    <div class="counter">
        <button @click="setQuantity(+quan-multiplicity)" class="counter__btn counter__btn--minus"> </button>
        <input v-model.lazy="quan" type="text" :readonly="readonly" class="counter__input">
        <button @click="setQuantity(+quan+multiplicity)" class="counter__btn counter__btn--plus"></button>
    </div>
</template>

<script>
export default {
    name: 'Quantity',
    props : {
        readonly : {
            type: Boolean,
            default : false,
        },
        value : {
            type : [ Number, String ],
            default : 1,
        },
        min : {
            type : Number,
            default : 1,
        },
        volume : {
            type : Number,
            default : 1,
        },
        multiplicity : {
            type : Number,
            default : 1,
        },
        max : {
            type : Number,
            default : 9999,
        },
    },
    data : () => ({
        quan : 0,
    }),
    watch : {
        value (val) {
            this.quan = +val;
        },
        quan (val) {
            //if(val <= 0){val = 1;}
            this.setQuantity(val);
        },
    },
    computed : {

    },
    mounted () {
        this.quan = +this.value;
    },
    methods : {
        setQuantity(quantity){
            if (quantity < this.min) {
                quantity = this.min;
            }
            if (quantity > this.max) {
                quantity = this.max;
            }
            if (quantity != this.quan) {
                this.quan = quantity;
                //this.$emit('input', quantity);
            }
            this.$emit('input', this.quan);
        },
    },
}
</script>
